import { useTranslation } from 'react-i18next';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { QuoteOptionApiModel } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';

export const QuoteOptionLabel = (props: { option: QuoteOptionApiModel; estimatedValue: number; currencyCode }) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  switch (props.option.CoverPercentage) {
    case 100:
      return props.estimatedValue
        ? t('QUOTE_OPTION_LABEL_PARTIAL_PROTECTION', {
            defaultValue: '{{amount}} protection',
            amount: toDisplayCurrency(props.currencyCode, props.estimatedValue)
          })
        : t('QUOTE_OPTION_LABEL_FULL_PROTECTION', { defaultValue: 'Fully protect my item' });
    case 0:
      return t('NO_ADDITIONAL_PROTECTION', { defaultValue: 'No additional protection' });
    default:
      return t('QUOTE_OPTION_LABEL_PARTIAL_PROTECTION', {
        defaultValue: '{{amount}} protection',
        amount: toDisplayCurrency(props.currencyCode, props.option.Covered)
      });
  }
};
